import { useField } from 'formik';
import QuillDelta from 'quill-delta';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { QuillInput } from '@treams/treams-ui';

const ErrorMessage = styled.p`
	color: ${(props) => props.theme.colors.danger};
	padding-top: 6px;
`;

export default function OpenQuestionInput(props: { name: string }) {
	const { t } = useTranslation();
	const [field, { error }] = useField<QuillDelta>(props.name);

	return (
		<>
			<QuillInput.Formik name={props.name} />
			{error && (
				<ErrorMessage>
					{t('validation.mixed.required').replace('${path}', t(`common.fields.${field.name}`))}
				</ErrorMessage>
			)}
		</>
	);
}
